import React from 'react';
import {URLS} from "@/lib/urls";
import {MasterLayout, SidebarItemWidget} from "@/components/layout/masetr/master";
import {Link} from 'react-router-dom'
import PermList from "@/lib/helper/PermList";
import {CanWhenHasAny} from "@/components/can/Can";

function AdminLayout({pageTitle, children, breadCrumb = undefined, backTo}) {


    const menu = [
        {
            name: 'داشبورد',
            path: URLS.admin.dashboard,
            icon: "icon-grid-2",
            can: null
        },

        {
            name: "نظرسنجی",
            path: URLS.admin.survey.dashboard,
            icon: "icon-chalkboard-user",
            can: PermList.SURVEY_LIST,
            children: [
                {
                    name: "لیست نظرسنجی",
                    path: URLS.admin.survey.dashboard,
                    can: PermList.SURVEY_LIST,
                },
                {
                    name: "ساخت نظرسنجی",
                    path: URLS.admin.survey.create,
                    can: PermList.SURVEY_ADD,
                },
                {
                    name: "نتایج نظرسنجی",
                    path: URLS.admin.survey.result,
                    can: PermList.SURVEY_RESULT,
                },

            ]
        },
        {
            name: "کدتخفیف",
            path: URLS.admin.discount.dashboard,
            icon: "icon-gift",
            can: PermList.DISCOUNT_LIST,
            children: [
                {
                    name: "لیست کدتخفیف",
                    path: URLS.admin.discount.list,
                    can: PermList.DISCOUNT_LIST,

                },
                {
                    name: "ساخت کدتخفیف",
                    path: URLS.admin.discount.create,
                    can: PermList.DISCOUNT_ADD,
                },

            ]
        },
        {
            name: 'محل‌های برگزاری کلاس',
            path: URLS.admin.classroom.dashboard,
            icon: "icon-grid-2",
            can: PermList.CLASSROOM_LIST
        },
        {
            name: 'درخواست بازگشت وجه',
            path: URLS.admin.refund.dashboard,
            icon: "icon-money-bill",
            can: PermList.REFUND_LIST
        },
        {
            name: 'سرفصل‌ها',
            path: URLS.admin.topic.dashboard,
            icon: "icon-book",
            can: PermList.TOPIC_LIST
        },
        {
            name: 'سامانه تحویل اقلام',
            path: URLS.admin.products.dashboard,
            icon: "icon-tag",
            can: PermList.PRODUCT_DASHBOARD
        },
    ]

    const userMenuElement = (<>


        <CanWhenHasAny permissions={[PermList.SETTINGS_LIST, PermList.SETTINGS_SMS_HISTORY_LIST]}>
            <div className="w-full h-[1px] bg-gray-400 dark:bg-gray-700 my-2"></div>
            <Link className="flex items-center gap-2 cursor-pointer" to={URLS.admin.setting.dashboard}>
                <i className="icon-gear"></i>
                <span className=" text-sm ">
                    تنظیمات
                </span>
            </Link>

        </CanWhenHasAny>

    </>)

    const sidebarFooterMenu = (
        <>
            <SidebarItemWidget item={
                {
                    name: "سطح دسترسی",
                    icon: "icon-shield-check",
                    path: URLS.admin.roles.dashboard,
                    can: PermList.ROLES_LIST
                }
            }/>
            <SidebarItemWidget item={
                {
                    name: "تنظیمات",
                    icon: "icon-gear",
                    path: URLS.admin.setting.dashboard,
                    can: PermList.SETTINGS_LIST,
                }}/>
        </>
    )

    return (
        <MasterLayout
            module={'admin'}
            pageTitle={pageTitle}
            breadCrumb={breadCrumb}
            sidebarMenu={menu}
            userMenu={userMenuElement}
            sidebarFooterMenu={sidebarFooterMenu}
            backTo={backTo}
        >
            {children}
        </MasterLayout>
    );
}

export default AdminLayout;